<template>
  <div class="container push-top">
    <loading-indicator v-if="contacts === false"></loading-indicator>
    <div class="no-contacts" v-if="contacts !== false && contacts.length <= 0">
      <img src="/images/sad.png">
      <h3>{{ $t('contacts.no_contacts_msg_title') }}</h3>
      <p>{{ $t('contacts.no_contacts_msg_body') }}</p>
      <a @click="Events.$emit('modalOpen', 'newContactModal')" class="button is-primary is-large">
        <span>{{ $t('contacts.add_contact') }}</span>
      </a>
      <button @click="showArchivedContacts = true" v-if="contacts !== false && !showArchivedContacts && archivedContacts.length > 0"
        class="button is-primary is-medium view-archived-contacts">{{ $t('contacts.view_archived_contacts') }}</button>
    </div>
    <div class="columns" v-if="contacts !== false && contacts.length > 0">
      <div class="column is-12">
        <div class="searchbox is-pulled-right">
          <span>
            <i class="icon icon-search"></i>
          </span>
          <input type="search" id="search" :placeholder="$t('search.placeholder')" v-model="search">
        </div>
        <h2 class="is-pulled-left">{{ $t('navigation.contacts') }}</h2>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <transition enter-active-class="animated fadeIn">
          <div class="table-wrapper" v-if="contacts !== false && contacts.length > 0">
            <table class="table">
              <thead>
                <tr>
                  <th @click="changeSort('name')">{{ $t('contacts.table.name') }}</th>
                  <th @click="changeSort('email')">{{ $t('contacts.table.email') }}</th>
                  <th @click="changeSort('company')">{{ $t('contacts.table.company') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody v-if="filteredContacts.length > 0">
                <tr v-for="contact in filteredContacts" :key="contact.id">
                  <td>{{ contact.name }}</td>
                  <td>
                    <a :href="'mailto:' + contact.email">{{ contact.email }}</a>
                  </td>
                  <td>{{ contact.company }}</td>
                  <td>
                    <div class="contact-options">
                      <a @click="Events.$emit('modalOpen', 'editContactModal', { contact : Object.assign({}, contact) })"
                        title="Edit Contact">
                        <i class="icon icon-edit"></i>
                      </a>
                      <a @click="Events.$emit('modalOpen', 'newDocumentModal', { contact : Object.assign({}, contact) })"
                        title="Send New Document">
                        <i class="icon icon-doc-new"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr>
                  <td colspan="4" class="empty-search">{{ $t('contacts.table.empty_search') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </transition>
        <button @click="showArchivedContacts = true" v-if="(contacts === false
          || contacts.length > 0) && !showArchivedContacts && archivedContacts.length > 0"
          class="button is-primary is-medium view-archived-contacts">{{ $t('contacts.view_archived_contacts') }}</button>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <h2 class="is-pulled-left archived-contacts" v-if="showArchivedContacts && archivedContacts.length > 0">{{ $t('contacts.archived_contacts') }}</h2>
      </div>
    </div>
    <div class="columns">
      <div class="column is-12">
        <transition enter-active-class="animated fadeIn">
          <div class="table-wrapper" v-if="showArchivedContacts && archivedContacts.length > 0">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ $t('contacts.table.name') }}</th>
                  <th>{{ $t('contacts.table.email') }}</th>
                  <th>{{ $t('contacts.table.company') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="contact in archivedContacts" :key="contact.id">
                  <td>{{ contact.name }}</td>
                  <td>
                    <a :href="'mailto:' + contact.email">{{ contact.email }}</a>
                  </td>
                  <td>{{ contact.company }}</td>
                  <td>
                    <div class="contact-options">
                      <a @click="Events.$emit('modalOpen', 'editContactModal', { contact : Object.assign({}, contact) })"
                        title="Edit Contact">
                        <i class="icon icon-edit"></i>
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </transition>
      </div>
    </div>
  </div>
</template>

<script>
import API from 'mixins/api';

export default {
  mixins: [API],
  data() {
    return {
      Events: window.Events,
      contacts: false,
      archivedContacts: false,
      filteredContacts: [],
      showArchivedContacts: false,
      search: '',
      sort: 'name',
      sortDirection: 1 // 0 asc, 1 desc
    }
  },
  beforeMount() {
    this.refreshContacts();
  },
  mounted() {
    this.Events.$on('createContact', this.refreshContacts);
    this.Events.$on('updateContact', this.refreshContacts);
    this.Events.$on('archiveContact', this.refreshContacts);
  },
  methods: {
    refreshContacts() {
      this.api().fetchTeamContacts()
        .then(contacts => this.contacts = contacts)
        .then(this.filterContacts);

      this.api().fetchArchivedTeamContacts()
        .then(archivedContacts => this.archivedContacts = archivedContacts);
    },
    filterContacts() {
      this.filteredContacts = [];

      if (this.search.length > 0) {
        this.filteredContacts =
          _.filter(this.contacts,
            contact => contact.name.toLowerCase().indexOf(this.search) > -1 ||
            contact.company.toLowerCase().indexOf(this.search) > -1
          );
      } else {
        this.filteredContacts = this.contacts;
      }

      this.doSort();
    },
    changeSort(attribute) {
      if (this.sort === attribute) {
        this.sortDirection = !this.sortDirection;
      } else {
        this.sort = attribute;
        this.sortDirection = 1;
      }

      this.doSort();
    },
    doSort() {
      if (this.sortDirection) {
        this.filteredContacts = _.sortBy(this.filteredContacts,
          contact => contact[this.sort].toLowerCase()
        );
      } else {
        this.filteredContacts = _.sortBy(this.filteredContacts,
            contact => contact[this.sort].toLowerCase())
          .reverse();
      }
    }
  },
  watch: {
    search() { this.filterContacts(); },
  }
}
</script>

<style lang="scss" scoped>
@import "resources/assets/sass/layout/_variables";
.no-contacts {
  width: 400px;
  background: $white;
  text-align: center;
  padding: 40px;
  border-radius: 2px;
  display: block;
  margin: 200px auto;
  border: 1px solid lighten($mutedblue, 12%);
  img {
    width: 60px;
    display: block;
    margin: 0 auto 26px;
  }
  h3 {
    font-size: 16px;
    text-transform: uppercase;
    font-weight: 600;
    margin: 0 0 20px;
    letter-spacing: 1px;
  }
  p {
    margin-bottom: 25px;
  }
}

.table-wrapper {
  border: 1px solid $white;
  background: $white;
  box-shadow: 0 2px 13px 1px rgba(211, 215, 221, 0.50);
  padding: 20px;
  min-height: 600px;
  border-radius: 5px;
  table {
    border-bottom: 1px solid lighten($mutedblue, 15%);
    thead {
      tr {
        th {
          text-transform: uppercase;
          letter-spacing: 1px;
          color: $grey;
          font-size: 12px;
          font-weight: 600;
          border-width: 0 0 1px;
        }
        &:hover {
          background-color: $white;
        }
      }
    }
    tbody {
      tr {
        td {
          vertical-align: inherit;
          &.empty-search {
            text-align: center;
          }
          a {
            color: $grey;
            &:hover {
              color: $green;
            }
          }
          .contact-options {
            text-align: right;
            font-size: 18px;
            padding-top: 4px;
            opacity: 0;
            -webkit-transition: all .3s ease;
            -moz-transition: all .3s ease;
            -ms-transition: all .3s ease;
            -o-transition: all .3s ease;
            transition: all .3s ease;
            a {
              color: $mutedblue;
              margin-left: 10px;
              i {
                &:hover {
                  color: $green;
                  cursor: pointer;
                }
              }
              &.edit {
                i {
                  margin-top: 1px;
                }
              }
            }
          }
        }
        &:hover {
          background-color: $eggshell;
          td {
            .contact-options {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}

.table td,
.table th {
  border: 1px solid lighten($mutedblue, 15%);
  border-width: 0 0 1px;
}

.table th {
  cursor: pointer;
}

.view-archived-contacts {
  margin: 20px 0;
}

h2.archived-contacts {
  margin-top: 44px;
}
</style>



// WEBPACK FOOTER //
// Contacts.vue?55dfae09